import { Currency } from '@search/filter-enums/enums/Currency';
import { formatPrice } from '@search/helpers/src/formatPrice';
import { FormType } from '../MortgageBuyOrDieModal';
import { calcMonthPayment } from './calculateBuyOrDie';

const REQUIRED_FIELD_TEXT = 'Обязательное поле';

export const validateFormFields = ({
    touched,
    formValues,
    mortgagePercent
}: {
    touched: { rent: boolean; ownAmount: boolean; propertyCost: boolean; comfortInvoice: boolean };
    formValues: FormType;
    mortgagePercent?: number;
}) => ({
    rent: validateRent({ touched: touched.rent, ...formValues }),
    comfortInvoice: validateComfortInvoice({ touched: touched.comfortInvoice, mortgagePercent, ...formValues }),
    ownAmount: validateOwnAmount({ touched: touched.ownAmount, ...formValues }),
    propertyCost: touched.propertyCost && formValues.propertyCost <= 0 ? REQUIRED_FIELD_TEXT : undefined,
});

function validateComfortInvoice(
    { touched, comfortInvoice = 0, mortgagePercent, propertyCost, ownAmount }:
    FormType & { touched: boolean; comfortInvoice?: number; mortgagePercent?: number }
) {
    if (touched) {
        if (comfortInvoice <= 0) return { isError: true, text: REQUIRED_FIELD_TEXT };
        if (comfortInvoice < 5000) return { isError: true, text: 'Слишком низкий платёж, на\u00A0покупку квартиры потребуется более 30\u00A0лет' };

        if (mortgagePercent) {
            const mortgagePaymentWithCurrentInvoice = calcMonthPayment({ mortgagePercent, sumCredit: propertyCost - ownAmount });

            if (mortgagePaymentWithCurrentInvoice > comfortInvoice) {
                const textMortgagePaymentWithCurrentInvoice = formatPrice({
                    value: (mortgagePaymentWithCurrentInvoice + 1) * 100,
                    currency: Currency.RUB,
                    noFractional: true,
                    displayCurrency: true
                });

                return { isError: true, text: `C\u00A0таким платежом вы\u00A0не\u00A0закроете ипотеку даже за\u00A030\u00A0лет. Минимальный платёж за\u00A0эту квартиру\u00A0— ${textMortgagePaymentWithCurrentInvoice}/мес.` };
            }
        }
    }
    return { isError: false, text: 'Cумма, которую вы\u00A0смогли\u00A0бы платить за\u00A0ипотеку, если\u00A0бы не\u00A0снимали квартиру' };
}

function validateOwnAmount({ touched, ownAmount = 0, propertyCost = 0 }: { touched: boolean; ownAmount?: number; propertyCost?: number }) {
    if (touched) {
        if (ownAmount > propertyCost) return { isError: true, text: 'Первый взнос не\u00A0больше стоимости квартиры' };
        if (ownAmount <= 0) return { isError: true, text: REQUIRED_FIELD_TEXT };
        if (ownAmount < (propertyCost / 100 * 15)) return { isError: true, text: 'Первый взнос не\u00A0менее\u00A015%' };
    }
    return { isError: false, text: 'Первый взнос не\u00A0менее\u00A015%' };
}

function validateRent({ touched, rent }: { touched: boolean; rent: number }) {
    if (touched) {
        if (rent < 0) return { isError: true, text: REQUIRED_FIELD_TEXT };
    }
    return { isError: false, text: 'Если вы\u00A0не\u00A0платите за\u00A0аренду\u00A0— оставьте поле пустым' };
}
